
const randInt = (min, max) => Math.floor(Math.random() * ((max - min) + 1)) + min;

const chooseFromArray = (array, howMany, repeatsAllowed = false) => {
  if (repeatsAllowed) {
    const randomIndexes = [];
    while (randomIndexes.length < howMany) {
      randomIndexes.push(randInt(0, array.length - 1));
    }
    return randomIndexes.map((randIndex) => array[randIndex]);
  }
  if (array.length < howMany) {
    throw new Error('\'howMany\' argument must be same or smaller as array length!');
  }

  const results = [];
  const arrayCopy = array.slice();
  while (results.length < howMany) {
    const randIndex = randInt(0, arrayCopy.length - 1);
    results.push(arrayCopy[randIndex]);
    arrayCopy.splice(randIndex, 1);
  }
  return results;

};


const randIntOrStaticValue = (min, max, staticValue = -1, probabilityOfStaticValue = 0.1) => {
  if (Math.random() <= probabilityOfStaticValue) {
    return staticValue;
  }
  return randInt(min, max);
};

const chooseOne = (arrayToChooseFrom) => arrayToChooseFrom[randInt(0, arrayToChooseFrom.length - 1)];

export { randInt, randIntOrStaticValue, chooseFromArray, chooseOne };
